module.exports = __webpack_public_path__ + "static/media/MentorAbbie.6954ec48.jpg";